/*
 * @Author: 
 * @Date: 2021-01-11 09:30:38
 * @LastEditors: 诺
 * @LastEditTime: 2023-04-27 09:26:02
 * @Description: file content
 * 
 */
// const Mock = require('mockjs');
// import baseFakeData from "./base-fake-data";
const tempName='circle-act-game-assistance'
export default {
    protocol: "",
    domain: "",
    action: {
        // 页面配置信息 -ui
        getConfig: {
            api: `${tempName}/act/m/page/getConfig`,
            method:'get',
            contentType:'json',
            mock: function () {
                return {
                    msg: "success",
                    code: 0,
                    data: {
                        value: "这里是假数据"
                    }
                }
            }
        },
        // 参与 围观人数
        counts:{
            api: `${tempName}/act/m/common/page/counts`,
            method:'get',
            contentType:'json',
        },
        // 轮播中奖信息
        homePrizeLogs:{
            api: `${tempName}/act/m/common/page/homePrizeLogs`,
            method:'get',
            contentType:'json',
        },
        // 获取排行榜奖品
        getRankPrize:{
            api: `${tempName}/act/m/page/getRankPrize`,
            method:'get',
            contentType:'json',
        },
        // // 获取抽奖奖品
        // getLotteryPrize:{
        //     api: `${tempName}/act/m/page/getLotteryPrize`,
        //     method:'get',
        //     contentType:'json',
        // },
        // 获取全部奖品
        prizeList:{
            // api: `${tempName}/act/m/common/page/prizeList`,
            api: `${tempName}/act/m/page/getLotteryPrize`,
            method:'get',
            contentType:'json',
        },
        // 获取优惠券奖品
        getCouponPrize:{
            api: `${tempName}/act/m/common/page/getCouponPrize`,
            method:'get',
            contentType:'json',
        },
        // 获取项目展示列表
        getProjectList:{
            api: `${tempName}/act/m/salesSite/listSalesSite`,
            method:'post',
            contentType:'json',
            type:'query'
        },

        // 参与活动
        participation:{
            api: `${tempName}/act/m/common/user/participation`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 获取游戏次数
        getGameNum:{
            api: `${tempName}/act/m/user/getUserLotteryTimesRemain`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 获取助力排行榜
        getAssistanceRank:{
            api: `${tempName}/act/m/common/user/getAssistanceRank`,
            method:'get',
            contentType:'json',
        },


        
        // 获取我的奖品
        getMyPrize:{
            api: `${tempName}/act/m/prize/myPrize`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 抽奖
        lottery:{
            api: `${tempName}/act/m/common/prize/lottery`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 核销
        writeOff:{
            api: `circle-act-manager/act/prize/writeOff`,
            method:'post',
            contentType:'json',
            type:'path'
        },
        getPrizeInfo:{
            api: `circle-act-manager/act/prize/getPrizeInfo`,
            method:'post',
            contentType:'json',
            type:'path'
        },
        // 获取验证码
        getSmsCode:{
            api: `${tempName}/act/m/common/smsCode`,
            method:'post',
            contentType:'json',
            type:'query'
        },
        // 分享
        share:{
            api: `${tempName}/act/m/common/user/share`,
            method:'post',
            contentType:'json',
            type:'query'
        },
        // 查询当前用户是否是销售
        getSaleByOpenId:{
            api: `${tempName}/act/m/sale/getSaleByOpenId`,
            method:'get',
            contentType:'json',
            type:'path'
        },
        // 获取当前用户助力值
        getAssistanceNumber:{
            api: `${tempName}/act/m/common/user/getAssistanceNumber`,
            method:'get',
            contentType:'json',
        },
        // 获取我的好友
        getAssistanceUser:{
            api: `${tempName}/act/m/user/getAssistanceUser`,
            method:'get',
            contentType:'json',
        },
        // 获取我的奖品code
        getReceivePrizeCode:{
            api: `${tempName}/act/m/user/getReceivePrizeCode`,
            method:'get',
            contentType:'json',
        },
        // 获取点亮人数
        accomplishLightCount:{
            api: `${tempName}/act/m/page/accomplishLightCount`,
            method:'get',
            contentType:'json',
        },
        // 获取站点
        getSite:{
            api: `${tempName}/act/m/user/getSite`,
            method:'get',
            contentType:'json',
        },
        // 站点抽奖
        assistanceLottery:{
            api: `${tempName}/act/m/prize/assistanceLottery/`,
            method:'post',
            contentType:'json',
        },
        // 站点奖品列表
        sitePrizeList:{
            api: `${tempName}/act/m/prize/sitePrizeList/`,
            method:'post',
            contentType:'json',
        },
        // 抽奖奖品列表
        getLotteryPrize:{
            api: `${tempName}/act/m/prize/getLotteryPrize`,
            method:'get',
            contentType:'json',
            type:'body'
        },
        // 锁定券库存
        lockCoupon:{
            api: `${tempName}/act/m/common/prize/lockCoupon/`,
            method:'post',
            contentType:'json',
        },
        // 获取支付链接
        getPaymentUrl:{
            api: `${tempName}/act/m/web/getPaymentUrl`,
            method:'post',
            contentType:'json',
        },

        // 领奖 - 后台锁定奖品 通过receiveKey领取
        receiveV2:{
            api: `${tempName}/act/m/common/prize/receive`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 领奖 - 后台未锁定奖品 通过prizeCode 领取
        win:{
            api: `${tempName}/act/m/common/prize/win`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 获取分享所需要的appid
        getShareAppId:{
            api: `${tempName}/act/m/common/getShareAppId`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 获取用户领奖次数余额
        getWinTimesRemain:{
            api: `${tempName}/act/m/user/getWinTimesRemain`,
            method:'get',
            contentType:'json',
            type:'body'
        },
        // 立即回收奖品
        recycle:{
            api: `${tempName}/act/m/common/prize/recycle`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 获取活动多人活码
        getWeChatQrCode:{
            api: `${tempName}/act/m/common/getWeChatQrCode`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 获取销售活码
        getSalesWeChatQrCode:{
            api: `${tempName}/act/m/common/getSalesWeChatQrCode`,
            method:'post',
            contentType:'json',
            type:'query'
        },
         // 获取佣金排行榜
         getShareUrl:{
            api: `${tempName}/act/m/common/getShareUrl`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        //投诉
        complaint:{
            api: `circle-act-manager/h5/complaint/save`,
            method:'post',
            contentType:'json',
            type:'body'
        },

        /**************************** 砍价相关 ************************************/
        
        // 获取砍价列表
        getBargainListIndex:{
            api: `${tempName}/act/m/page/getBargainList`,
            method:'get',
            contentType:'json',
        },
        // 获取我的砍价列表
        getMyBargainList:{
            api: `${tempName}/act/m/prize/getMyBargainList`,
            method:'get',
            contentType:'json',
        },
        // 用户当前砍价状态 0未开始 1 进行中 2 已达金额
        getBargainStatus:{
            api: `${tempName}/act/m/user/getBargainStatus`,
            method:'get',
            contentType:'json',
        },
        // 获取用户当前砍价奖品
        getUserCurBargain:{
            api: `${tempName}/act/m/prize/getUserCurBargain`,
            method:'get',
            contentType:'json',
        },
        // 获取帮砍好友信息
        getBargainHelper:{
            api: `${tempName}/act/m/user/getBargainHelper`,
            method:'get',
            contentType:'json',
        },
        // 发起砍价
        launchBargain:{
            api: `${tempName}/act/m/user/launchBargain`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 锁定砍价红包
        lockBargainRedPac:{
            api: `${tempName}/act/m/prize/lockBargainRedPac`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 自砍
        selfBargain:{
            api: `${tempName}/act/m/user/selfBargain`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 取消砍价
        cancelBargain:{
            api: `${tempName}/act/m/prize/cancelBargain`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 领取砍价商品
        receiveBargain:{
            api: `${tempName}/act/m/prize/receiveBargain`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 帮砍
        helpBargain:{
            api: `${tempName}/act/m/user/helpBargain`,
            method:'post',
            contentType:'json',
            type:'body'
        },


        // 判断奖品是否可以领取
        checkWinCondition:{
            api: `${tempName}/act/m/common/prize/checkWinCondition`,
            method:'post',
            contentType:'json',
            type:'body'
        },

        // 核销
        writeOff2:{
            api: `circle-write-off/m/writeOffCode/writeOff`,
            method:'post',
            contentType:'json',
            type:'path'
        },
        detail:{
            api: `circle-write-off/m/writeOffCode/detail`,
            method:'post',
            contentType:'json',
            type:'path'
        },
        infoList:{
            api: `${tempName}/act/m/common/appointment/infoList`,
            method:'get',
            contentType:'json',
            type:'body'
        },
        signUp:{
            api: `${tempName}/act/m/common/appointment/signUp`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        signUpUserList:{
            api: `${tempName}/act/m/common/appointment/signUpUserList`,
            method:'post',
            contentType:'json',
            type:'body'
        },
        signUpDetail:{
            api: `${tempName}/act/m/common/appointment/signUpDetail`,
            method:'post',
            contentType:'json',
            type:'body'
        },
    },
}